module.exports = __webpack_public_path__ + "static/2-2a799afdd8716dbb3045baf362fda97d.jpg";